fbHiddenDirective.$inject = ['$compile', '$animate'];

export default function fbHiddenDirective($compile, $animate) {
  return {
    multiElement: true,
    transclude: 'element',
    priority: 600,
    restrict: 'A',
    $$tlb: true,
    scope: false,
    require: '^^?ecFormBuilder',
    link,
  };

  function link(scope, element, attrs, ecFormBuilderController, $transclude) {
    ecFormBuilderController = ecFormBuilderController || searchInScope(scope);
    if (!ecFormBuilderController) {
      return;
    }

    const { registerName, name } = JSON.parse(attrs.fbHidden);
    const { showElement, hideElement } = toggleFactory();
    const isVisible = !ecFormBuilderController.isHiddenField(registerName, name);
    //
    isVisible && showElement(); // render
    const unbind = ecFormBuilderController.events.on(`ecFormBuilder:fbHidden:${registerName}:${name}`, ({ hide }) => {
      hide ? hideElement() : showElement();
      // ecFormBuilderController.updateStateField(registerName, name, hide);
    });

    scope.$on('$destroy', () => {
      unbind();
    });

    ///////////////////////////////////////////////////////////////////////////

    function searchInScope(context, repetition = 0) {
      // busca el ecFormBuilderController en el scope y sus padres, con un maximo de 15 parents para que
      // no busque hasta raiz
      if (repetition === 15) {
        console.error('fbHidden ecFormBuilderController no encontrado', element[0]);
        return;
      }
      if (context.ecFormBuilderController) {
        return context.ecFormBuilderController;
      } else {
        return searchInScope(context.$parent, repetition + 1);
      }
    }

    function toggleFactory() {
      let block, childScope, previousElements;
      return { showElement, hideElement };

      function showElement() {
        if (!childScope) {
          $transclude(function(clone, newScope) {
            childScope = newScope;
            clone[clone.length++] = $compile.$$createComment('end fbHidden', attrs.fbHidden);
            // Note: We only need the first/last node of the cloned nodes.
            // However, we need to keep the reference to the jqlite wrapper as it might be changed later
            // by a directive with templateUrl when its template arrives.
            block = {
              clone: clone,
            };
            $animate.enter(clone, element.parent(), element);
          });
        }
      }

      function hideElement() {
        if (previousElements) {
          previousElements.remove();
          previousElements = null;
        }
        if (childScope) {
          childScope.$destroy();
          childScope = null;
        }
        if (block) {
          previousElements = getBlockNodes(block.clone);
          $animate.leave(previousElements).done(function(response) {
            if (response !== false) {
              previousElements = null;
            }
          });
          block = null;
        }
      }

      function getBlockNodes(nodes) {
        // TODO(perf): update `nodes` instead of creating a new object?
        let node = nodes[0];
        const endNode = nodes[nodes.length - 1];
        let blockNodes;

        for (let i = 1; node !== endNode && (node = node.nextSibling); i++) {
          if (blockNodes || nodes[i] !== node) {
            if (!blockNodes) {
              blockNodes = jqLite(slice.call(nodes, 0, i));
            }
            blockNodes.push(node);
          }
        }

        return blockNodes || nodes;
      }
    }
  }
}
